import { render, staticRenderFns } from "./SunCreateOrUpdate.vue?vue&type=template&id=1b985c79"
import script from "./SunCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./SunCreateOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports